module.exports = __webpack_public_path__ + "static/media/7.abdac9d3.jpg";